import * as z from "zod/v4";

export enum ConvertTokenError {
  ExpiredToken = "ExpiredToken",
  InvalidToken = "InvalidToken",
}
export const convertTokenToCustomerAuth = {
  name: "convertTokenToCustomerAuth" as const,
  input: z.object({
    emailToken: z.string().nullish(),
    exchangeConversionEmailToken: z.string().nullish(),
    orderTrackingToken: z.string().nullish(),
  }),
  output: z.object({
    customerAuthToken: z.string(),
    customer: z.object({
      name: z.string(),
      email: z.string(),
      customerId: z.string(),
    }),
    orderId: z.string().nullish(),
  }),
};
